import { Injectable } from '@angular/core';
import { AppSettings } from 'app/app.settings';
import { UserService } from './user.service';
import { CommonRequestService } from './common-request.service';

export interface MapBookmark {
	id;
	name: string;
	desc: string;
	module: 'AZGIv';
	userId: number;
	userName: string;
	cusId: number;
	visibility: BookmarkVisibilityValue;
	type: BookmarkTypeValue;
	bbox?: number[];
	href?: string;
	ownerDisplay: string;
}
export type BookmarkVisibilityValue = 'Personal' | 'Agency' | 'State' | 'System';
export type BookmarkTypeValue = 'BBOX' | 'HREF';

export interface BookmarkVisibilityItem {
	label: string;
	value: BookmarkVisibilityValue;
}

@Injectable({
  providedIn: 'root'
})
export class BookmarkService {

	bookmarkVisibilities: BookmarkVisibilityItem[] = [{
		label: 'Personal',
		value: 'Personal'
	}, {
		label: 'Agency',
		value: 'Agency'
	}, {
		label: 'State',
		value: 'State'
	}];
	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

	getMapBookmarks(type?: BookmarkTypeValue): Promise<MapBookmark[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/bookmarks';
			this.requestService.requestGet(url, {
				params: {
					userId: this.userService.getUserInfo().userId,
					application: AppSettings.appName,
					type: type
				}
			}, (rsp) => {
				const bookmarkList: MapBookmark[] = [];
				if (rsp.data) {
					// if (type === 'HREF') {
					// 	rsp.data = [
					// 		{
					// 			"bkm_id": 27,
					// 			"bkm_mod_cd": "AZGIV",
					// 			"bkm_name": "NG911 GIS Data Model",
					// 			"bkm_description": "NENA Standards - NG911 GIS Data Model",
					// 			"usr_id": 0,
					// 			"usr_name": "admin",
					// 			"usr_cus_id": 0,
					// 			"bkm_visibility": "System",
					// 			"bkm_type": "HREF",
					// 			"bkm_bbox": null,
					// 			"bkm_href": "https://cdn.ymaws.com/www.nena.org/resource/resmgr/standards/nena-sta-006.2a_ng9-1-1_gis_.pdf"
					// 		},
					// 		{
					// 			"bkm_id": 28,
					// 			"bkm_mod_cd": "AZGIV",
					// 			"bkm_name": "USPS Pub 28 - Addressing Standards",
					// 			"bkm_description": "USPS Pub 28 - Addressing Standards",
					// 			"usr_id": 0,
					// 			"usr_name": "admin",
					// 			"usr_cus_id": 0,
					// 			"bkm_visibility": "System",
					// 			"bkm_type": "HREF",
					// 			"bkm_bbox": null,
					// 			"bkm_href": "https://pe.usps.com/text/pub28/welcome.htm"
					// 		}
					// 	]
					// }
					rsp.data.forEach((d) => {
						const bm: MapBookmark = {
							id: d.bkm_id,
							name: d.bkm_name,
							desc: d.bkm_description,
							module: d.knm_mod_cd,
							visibility: d.bkm_visibility,
							type: d.bkm_type,
							bbox: d.bkm_bbox,
							href: d.bkm_href, // TODO
							userId: d.usr_id,
							userName: d.usr_name,
							cusId: d.usr_cus_id,
							ownerDisplay: d.usr_name.split('@')[0]
						};
						bookmarkList.push(bm);
					});
				}
				resolve(bookmarkList);
			}, (err) => {
				reject(err);
			});
		});
	}
	addMapBookmarks(name: string, desc: string, visib: BookmarkVisibilityValue, type: BookmarkTypeValue, bbox?: number[], href?: string) {
		const url = AppSettings.serviceRootUrl + 'admin/bookmarks';
		return new Promise<void>((resolve, reject) => {
			const body: any = {
				name: name,
				description: desc,
				visibility: visib,
				type: type,
				userId: this.userService.getUserInfo().userId,
				application: AppSettings.appName
			};
			if (type === 'HREF') {
				body.href = href;
			} else {
				body.bbox = JSON.stringify(bbox)				
			}
			this.requestService.requestPost(url, body, () => resolve(), (err) => reject(err));
		})
	}
	deleteMapBookmark(id): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/bookmarks';
			const body = {
				id: id
			};
			this.requestService.requestDelete(url, {
				body: body
			}, () => resolve(), (err) => reject(err));
		});
	}
}
